import { observer } from 'mobx-react';
import { autoinject, inject, SubTopBar, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Route } from 'react-router-dom';
import { Button } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { Clients } from '../Manage/Clients';
import { UserProfile } from '../Manage/UserProfile';
import { CloseAccount } from './CloseAccount';
import { DeviceLogins } from './DeviceLogins';
import { LookAndFeel } from './LookAndFeel';

export interface IPreferencesProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class Preferences extends React.Component<IPreferencesProps> {
    public render() {
        return (
            <div className="container-fluid pt-3">
                <Title>Preferences</Title>

                <SubTopBar>
                    <LinkContainer exact to="/preferences" className="nav-link stat-link fw-bold">
                        <Button color="link" className="fw-bold">
                            User Profile
                        </Button>
                    </LinkContainer>
                    {this.accountStore.isInRoles(['MriAdmin', 'MriUser', 'PortalUser', 'PortalAdmin']) && (
                        <>
                            <LinkContainer exact to="/preferences/look-feel" className="nav-link stat-link fw-bold">
                                <Button color="link" className="fw-bold">
                                    Interface
                                </Button>
                            </LinkContainer>

                            <LinkContainer exact to="/preferences/clients" className="nav-link fw-bold d-inline-block">
                                <Button color="link" className="nav-link stat-link fw-bold">
                                    Client Apps
                                </Button>
                            </LinkContainer>

                            <LinkContainer
                                exact
                                to="/preferences/device-logins"
                                className="nav-link fw-bold d-inline-block"
                            >
                                <Button color="link" className="nav-link stat-link fw-bold">
                                    Device Logins
                                </Button>
                            </LinkContainer>

                            <LinkContainer
                                exact
                                to="/preferences/close-account"
                                className="nav-link fw-bold d-inline-block"
                            >
                                <Button color="link" className="nav-link stat-link fw-bold">
                                    Close Account
                                </Button>
                            </LinkContainer>
                        </>
                    )}
                </SubTopBar>

                <div className="container-fluid p-4 preferences-content rounded">
                    <div className="row">
                        <Route path="/preferences" exact component={UserProfile} />
                        <Route path="/preferences/clients" component={Clients} />
                        <Route path="/preferences/look-feel" component={LookAndFeel} />
                        <Route path="/preferences/device-logins" component={DeviceLogins} />
                        <Route path="/preferences/close-account" component={CloseAccount} />
                    </div>
                </div>
            </div>
        );
    }

    @inject
    private accountStore!: AccountStore;
}
